import axios from "axios";
import Config from "./Config";

export const buildSamlLoginUrl = (slug, returnTo) => {
  const target = returnTo || `${Config.HOST_URL_live_clever}${Config.SAML_CALLBACK_PATH}`;
  const qs = new URLSearchParams({ returnTo: target }).toString();
  return `${Config.SAML_SSO_BASE}/auth/saml/${encodeURIComponent(slug)}/login?${qs}`;
};

export const lookupSamlByEmail = async (email) => {
  const trimmed = (email || "").trim();
  if (!trimmed || !trimmed.includes("@")) {
    return { ok: false, status: 400, message: "Enter a valid email address." };
  }
  try {
    const res = await axios.get(`${Config.SAML_SSO_BASE}/auth/saml/lookup`, {
      params: { email: trimmed },
      timeout: 10000,
      validateStatus: () => true,
    });
    if (res.status === 200 && res.data?.slug) {
      return { ok: true, ...res.data };
    }
    if (res.status === 404) {
      return {
        ok: false,
        status: 404,
        message: "Your district isn't enrolled in single sign-on yet. Sign in with your email and password instead.",
      };
    }
    return {
      ok: false,
      status: res.status || 500,
      message: res.data?.error || "Single sign-on lookup failed. Try again.",
    };
  } catch (e) {
    return {
      ok: false,
      status: 0,
      message: "Couldn't reach the single sign-on service. Check your connection and try again.",
    };
  }
};
